define('shared/remote/member/create',[
    'shared/remote/ajax',
    'shared/lib/RSVP',
    './cache',
    '../util/MemberLeadPayloadCreator'
], 
function(
    ajax, 
    RSVP,
    cache,
    MemberLeadPayloadCreator
) {
    return function(options){
        return RSVP.resolve()
            .then(function(){
                return MemberLeadPayloadCreator.instance.create(options);
            })
            .then(function(data){
                return ajax({
                    url: '/1/api/commerce-gateway/member',
                    method: 'put',
                    data: data
                });
            })
            .then(function(memberData){
                return cache.set(memberData);
            });
    };
});
